export default __webpack_public_path__ + "static/media/17.7939e3b4.mp3";